export default __webpack_public_path__ + "static/media/dst.5c6af967.jpg";